module.exports = __webpack_public_path__ + "static/media/73.eccc9b49.gif";